import App from './App.vue'
import {createApp} from 'vue'
import router from './routes'
import store from './data/store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import vue3GoogleLogin from 'vue3-google-login'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/theme-chalk/dark/css-vars.css'
import 'bootstrap'; // loads bootstrap JS
import $ from 'jquery';
import 'popper.js'
import {QuillEditor} from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

window.$ = $;

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
        .component('QuillEditor', QuillEditor)
}
createApp(App)
    .use(router)
    .use(store)
    .use(ElementPlus)
    .use(vue3GoogleLogin, {
        clientId: '992002134203-614usu42d3ubk11fgkctme25bar1ga3n.apps.googleusercontent.com'
    })
    .mount("#app")

